<template>
    <a :href="`https://${company.subdomain}.camaq.ca`">
        <div class="relative flex flex-col justify-between h-[250px] p-8 bg-white rounded-md shadow">
            <div>
                <h1 class="text-xl leading-tight font-bold">{{ company.name }}</h1>
                <p v-if="company.offers_count">{{ company.offers_count }} {{ $t('job offers') }}</p>
            </div>

            <div>
                <img loading="lazy" :src="company.logo" alt="" class="object-contain w-full h-24">
            </div>
        </div>
    </a>
</template>

<script>
    export default {
        props: {
            company: Object,
        },
    }
</script>